import { render } from "./AssessementPersonalInfo.vue?vue&type=template&id=4d9a87e3"
import script from "./AssessementPersonalInfo.vue?vue&type=script&lang=js"
export * from "./AssessementPersonalInfo.vue?vue&type=script&lang=js"

import exportComponent from "/Users/macbookpro/Herd/hris-laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__